import React, { Fragment } from 'react';
import { Radio, Spin, Alert, Empty, Form } from 'antd';
import FormItem from '../FormItem/FormItem';
import { useAvailablePaymentState } from '../../api/availablePaymentStateQuery';
import { fieldNames } from '../../config/form';
import styles from './PaymentStateField.module.scss';

const renderContent = ({
  isDataEmpty,
  isPaymentLocked,
  getFieldDecorator,
  paymentState,
}) => {
  if (isDataEmpty) return <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />;

  if (isPaymentLocked)
    return (
      <Alert
        style={{ marginTop: 6 }}
        message="Статус оплаты автоматически перейдет в «Оплачено», когда собственник
  произведет оплату"
        type="info"
        showIcon
      />
    );

  return getFieldDecorator(fieldNames.paymentState)(
    <Radio.Group>
      <Radio value={paymentState?.id}>{paymentState?.name}</Radio>
    </Radio.Group>
  );
};

const PaymentStateField = ({ form, currentPaymentStateId, paymentTypeId }) => {
  const { getFieldDecorator } = form;

  const { data, isFetching } = useAvailablePaymentState(
    { paymentTypeId, currentPaymentStateId },
    {
      staleTime: Infinity,
      enabled: Boolean(paymentTypeId && currentPaymentStateId),
      notifyOnChangeProps: ['data', 'isFetching'],
    }
  );

  const paymentState = data?.paymentState;

  const isDataEmpty = !isFetching && !paymentState;
  const isPaymentLocked = paymentState?.id === 0;

  const Container = isDataEmpty || isPaymentLocked ? Fragment : Form;

  return (
    <Container>
      <Spin spinning={Boolean(isFetching)}>
        <FormItem
          label="Статус оплаты"
          className={styles.formItem}
          colon={false}
        >
          {renderContent({
            isDataEmpty,
            isPaymentLocked,
            getFieldDecorator,
            paymentState,
          })}
        </FormItem>
      </Spin>
    </Container>
  );
};

export default PaymentStateField;
